import React, { Component } from 'react'

export default class Title extends Component {
  render() {
    return (
      <div>
        <div className="text-center">
          <h1 className="h4 text-gray-900 mb-4">Hallo Admin</h1>
        </div>
      </div>
    );
  }
}
